import { useEffect } from "react";
import api from "../api/notifications";
import { NotificationViewComponent } from '../components/notificationview';

const Notifications = ({ notifications, setNotifications, search, setSearch }) => {

    useEffect(() => {
        const fetchNotifications = async () => {
            try {
                const response = await api.get("/");
                setNotifications(response.data);
            } catch (err) {
                console.log("Fetch error:", err.response?.status);
            }
        };

        fetchNotifications();
    }, [setNotifications]);

    return (
        <main className="Home">
            <NotificationViewComponent
                notifications={notifications}
                setNotifications={setNotifications}
                search={search}
                setSearch={setSearch}/>
        </main>
    )
}

export default Notifications;